import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { easeOutCubic } from '../../utils';
import { CrossIcon } from '../Icons';

export const Toast = ({
  children,
  isOpen,
  handleClose,
  autoClose = 0,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  handleClose: () => void;
  autoClose?: number;
}) => {
  useEffect(() => {
    if (isOpen && autoClose > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, autoClose);
      return () => {
        // Cleanup timer on unmount or when isOpen changes
        clearTimeout(timer);
      };
    }
    return undefined;
  }, [isOpen, autoClose, handleClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="p-6 fixed bottom-0 left-0 z-50 flex w-full justify-center"
          initial={{ opacity: 0, y: 50 }}
          animate={{
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: easeOutCubic },
          }}
          exit={{
            opacity: 0,
            y: 50,
            transition: { duration: 0.3, ease: easeOutCubic },
          }}
        >
          <div
            className="flex items-center px-4 py-2 rounded-2xl text-white max-w-[540px]"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#dd74b5',
            }}
          >
            {children}
            <CrossIcon onClick={handleClose} className="cursor-pointer" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
